// https://www.one.com/ajax-add-transfer-domain.do?move=true
// extraDomainName=amazon&extraDomainSuffix=.asia

export const transferDomain =
  (domain, tld, authCode) =>
  (dispatch, getState, { api }) =>
    // API call
    api.transferDomain(encodeURIComponent(domain), tld, authCode).then(
      (data) => data,
      (err) => {},
    );
